import { Paper as MuiPaper, styled } from '@mui/material';

export const Paper = styled(MuiPaper)(({ theme }) => ({
  boxShadow: `0px 3px 5px rgba(0, 0, 0, 0.2), 0px 5px 8px rgba(0, 0, 0, 0.14), 0px 1px 14px rgba(0, 0, 0, 0.12)`,
  overflow: 'hidden',
  maxWidth: 732,
  marginLeft: 'auto',
  marginRight: 'auto',
}));
